export default {
    backText: 'Back to collections',
    title: 'Add Collection',
    editTitle: 'Edit Collection',
    search: 'Search Products',
    image: 'Image',
    successEditMessage: 'Collection updated successfully',
    details: {
        title: 'Collection details',
        collectionTitle: {
            title: 'Title',
            placeholder: 'Enter title'
        },
        description: {
            title: 'Description (optional)',
            placeholder: 'Enter description'
        }
    },
    button: {
        add: 'Add Collection',
        update: 'Update Collection',
        cancel: 'Cancel'
    },
    products: {
        title: 'Products',
        subtitle: 'Add products to the collection',
        addProduct: 'Add Product',
        emptyCollection: 'There are currently no products in your collection.'
    },
    activity: {
        status: 'Collection is active.',
        status2: 'Collection is not active.',
        description:
            'Active collections are visible in the store. The activity of the collection can change even after its addition'
    },
    addProductModal: {
        cancel: 'Cancel',
        addProducts: 'Add Products',
        add: 'Add',
        paginatorText: 'products'
    }
};
